// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"c2f0cce5","208":"b27820dd","329":"b35a1b27","446":"3389e9a1","591":"141f66e5","630":"4b7ba497","825":"6f75db09","828":"9f25deb2"}[chunkId] + ".chunk.js";
};